import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ValidadorServiceService } from '../../services/validador-service.service';
import { CellDateFormatterComponent } from '../cell-date-formatter/cell-date-formatter.component';
import { ValidadorEditComponent } from '../validador-edit/validador-edit.component';

@Component({
  selector: 'app-validador',
  templateUrl: './validador.component.html',
  styleUrls: ['./validador.component.scss']
})
export class ValidadorComponent implements OnInit {

  public translate: TranslateService;
  public columnDefs: any[];
  private gridApi;
  public rowData: any;
  dialogConfig: MatDialogConfig;

  constructor(private _ValidadorService: ValidadorServiceService, private _router: Router, private _route: ActivatedRoute, private _dialog: MatDialog, _translateService: TranslateService) {
    this.translate = _translateService;
    this.columnDefs = this.createColumnDef();
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.closeOnNavigation = true;
    this.dialogConfig.width = '700px';
    this.dialogConfig.maxHeight = '80%';
  }

  ngOnInit() {
    this.loadData();
  }

  createColumnDef() {
    const columnDefs = [
      {
        headerName: 'Eliminar', field: 'id', suppressFilter: true, suppressSorting: true,
        template: `<a data-action-type="remove"><i data-action-type="remove" class="fa fa-remove text-danger"></i></a>`,
        width: 100
      },
      {
        headerName: 'Editar', field: 'id', cellClass: 'grid-opendialog',
        template: `<i class="fa fa-edit text-info"></i>`,
        width: 100
      },
      { headerName: this.translate.instant('administracion.ag_fullName'), field: 'nombreCompleto', width: 200, minWidth: 150 },
      { headerName: this.translate.instant('administracion.ag_email'), field: 'email', width: 200, minWidth: 150 },
      { headerName: this.translate.instant('clientes_edit.camp_ciudad'), field: 'ciudad', width: 200, minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.createdDate'), field: 'createdDate', cellRendererFramework: CellDateFormatterComponent, width: 250, minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.createdByName'), field: 'createdByName', width: 250, minWidth: 150, suppressSizeToFit: false },
      { headerName: this.translate.instant('auditableEntity.updatedDate'), field: 'updatedDate', cellRendererFramework: CellDateFormatterComponent, width: 250, minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.updatedByName'), field: 'updatedByName', width: 250, minWidth: 150 },
      {
        headerName: this.translate.instant('tasacion_edit.camp_visit'), field: 'visitador', minWidth: 150, valueFormatter: function (params) {
          return params.value ? 'Sí' : 'No';
        }
      }
    ]

    return columnDefs;
  }

  public defaultColDef = {
    width: 100,
    filter: 'agTextColumnFilter'
  };

  loadData() {
    this._ValidadorService.getValidadores().subscribe(data => this.rowData = data);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  public newItem() {
    let ref = this._dialog.open(ValidadorEditComponent, this.dialogConfig);
    ref.componentInstance.isModal = true;
    ref.afterClosed().subscribe(result => {
      console.log('New Item: ' + result);
      this.loadData();
    });
  }

  public onCellClickedEvent($event) {
    if ($event.event.target !== undefined) {
      let data = $event.data;
      let actionType = $event.event.target.getAttribute("data-action-type");

      switch (actionType) {
        case "remove":
          return this.onActionRemoveClick(data);
      }
    }
    if ($event.colDef.cellClass !== undefined && $event.colDef.cellClass.indexOf("grid-opendialog") >= 0) {
      let dlgRef = this._dialog.open(ValidadorEditComponent, this.dialogConfig);
      dlgRef.componentInstance.id = $event.data.id;
      dlgRef.componentInstance.isModal = true;
      dlgRef.afterClosed().subscribe(result => {
        console.log('onCellClickedEvent: ' + result)
        this.loadData();
      })
    }
  }

  onActionRemoveClick(data: any) {
    var ans = confirm("Quieres eliminar el registro con Id: " + data.id);
    if (ans) {
      this._ValidadorService.delete(data.id).subscribe((data: any) => {
        if (data.estado == "Error") {
          alert("Este validador está asociado a alguna tasación, por lo que no se puede borrar. Si lo desea puede marcarlo como inactivo.");
        }
        this.loadData();
      });
    }
  }

}
